import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../config";
import FullScreenLoader from "../components/FullScreenLoader";
import LeftPanel from "../components/leftPanel";
import { analytics } from "../components/firebase";
import { logEvent } from "firebase/analytics";
import { toast, ToastContainer } from "react-toastify";
import GoogleButton from "../components/GoogleAuth";
import { Helmet } from "react-helmet-async";
const CriminalCharge = () => {
  const [selectType, setselectType] = useState("");
  const [SupportiveInput, setSupportiveInput] = useState("");
  const [SupportiveInput2, setSupportiveInput2] = useState("");
  const [language, setLanguage] = useState("");
  const [level, setLevel] = useState("Short");
  const [selectedButton, setSelectedButton] = useState("button1");
  const [user] = useState(JSON.parse(localStorage.getItem("userProfile")));
  const [errors, setErrors] = useState({});
  const [popupMessage] = useState("");
  const [isPopupVisible] = useState(false);
  const textAreaRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const googleAuthRef = useRef(null);
  const [formData, setFormData] = useState({
    offensedescription: "",
    defendantname: "",
    jobDescription: "",
    dateandtimeofoffense: "",
    employementType: "",
    locationofoffense: "",
    arrestdetails: "",
    CourtJurisdiction: "",
    witnessnames: "",
    lawyersdetails: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);

  const initialText = location.state?.text || "";
  const receivedKey = location.state?.key || "Legal Document";
  const [Topic, setTopic] = useState(initialText);
  const [Keypoints, setKeypoints] = useState("");

  const handleButtonClick = (selectedLevel) => {
    setLevel(selectedLevel);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleOutlineClick = (buttonId) => {
    setSelectedButton(buttonId);
  };

  const handleGenerate = async () => {
    setIsLoading(true);
    setIsButtonVisible(false);
    document.body.classList.add("no-scroll");

    try {
      const requestBody = {
        ...formData,
        selectedLanguage: language,
      };

      console.log("About to call endpoint with payload:", requestBody);

      const generationResponse = await fetch(
        `${config.baseURL}/criminal_gen.php`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );

      const rawResponse = await generationResponse.text();
      let data;

      try {
        data = JSON.parse(rawResponse);
      } catch {
        toast.error("Please re-try after some time");
        return;
      }

      if (data.error) {
        if (data.error === "Authentication failed") {
          
          googleAuthRef.current?.login();
          return;
        }
        if (data.redirect === "premium") {
          navigate(`/premium?id=${data.premiumId}`);
          return;
        }
        toast.error("Please re-try after some time");
        return;
      }

      if (data.success && data.resultText) {
        navigate("/result", {
          state: { result: data.resultText, history_id: data.history_id },
        });
        setFormData({
          offensedescription: "",
          defendantname: "",
          jobDescription: "",
          dateandtimeofoffense: "",
          employementType: "",
          locationofoffense: "",
          arrestdetails: "",
          CourtJurisdiction: "",
          witnessnames: "",
          lawyersdetails: "",
        });
        setLanguage("English");
      } else {
        toast.error("Please re-try after some time");
      }
    } catch (error) {
      toast.error("Please re-try after some time");
      logEvent(analytics, "error", {
        error_type: "Criminal Charges Api Failed",
        error_message: "Failed to generate document due to API error.",
        action: "generate_button_click",
      });
    } finally {
      setIsLoading(false);
      document.body.classList.remove("no-scroll");
    }
  };

  const handleLoginSuccess = () => {
    toast.success("Login complete.");
  };
  const handleLoginFailure = () => {};

  return (
    <>
      {/*  <div className="createPageTop">
                <img src={config.Backbutton} alt="back icon" onClick={handleBackClick} />
                Create AI Legal Document
            </div> */}
      <Helmet key="landing">
        <title>
          AI Criminal Charge Statement Generator | Create Offense Reports Online
        </title>

        <meta
          name="description"
          content="Easily generate detailed criminal charge documents using our AI-powered platform. Customize defendant details, offense description, arrest info, witnesses, and jurisdiction. Trusted by law firms and legal professionals."
        />

        <meta
          name="keywords"
          content="criminal charge generator, AI offense report, legal charge document, create criminal case summary, court document automation, AI legal tool, arrest report template, offense statement form, customizable criminal charges, online legal reporting, defendant charge generator, municipal court forms, legal accusation builder"
        />

        <link
          rel="canonical"
          href="https://legaldocumentgenerator.com/criminal-charges-templates"
        />
      </Helmet>

      <div className="create_background">
        {isLoading && <FullScreenLoader />}
        {isPopupVisible && (
          <div className="popup-notification">
            <p>{popupMessage}</p>
          </div>
        )}

        <LeftPanel />
        <div className="create_main_templates">
           <div className="create_title">
             <img src={config.Backbutton} alt="back" onClick={handleBackClick} />
             Create AI Legal Document
            </div>
          <div className="create_form_grid">
            {[
              {
                label: "Defendant's full name",
                name: "defendantname",
                placeholder: "e.g, John Smith",
              },
              {
                label: "Offense description",
                name: "offensedescription",
                placeholder: "e.g, Theft of property valued at $5,000",
              },
              {
                label: "Date and time of the offense",
                name: "dateandtimeofoffense",
                placeholder: "e.g., 25th November 2024, 3:00 PM",
              },
              {
                label: "Location of the offense",
                name: "locationofoffense",
                placeholder: "e.g., 123 Main Street, Springfield",
              },
              {
                label: "Arrest details (if applicable)",
                name: "arrestdetails",
                placeholder:
                  "e.g., Arrested at the scene by officer Jane Smith, Badge#12345",
              },
              {
                label: "Witness names (if applicable)",
                name: "witnessnames",
                placeholder: "e.g., Jane Doe, Mark Johnson",
              },
              {
                label: "Lawyer's details",
                name: "lawyersdetails",
                placeholder:
                  "e.g., Attorney Sarah Blake, contact: (123) 456-7890",
              },
              {
                label: "Court jurisdiction",
                name: "CourtJurisdiction",
                placeholder: "e.g., Municipal Court, Los Angeles Court",
              },
            ].map(({ label, name, placeholder }) => (
              <div className="create_inputbox1" key={name}>
                {label}
                <textarea
                  className="textarea_input"
                  name={name}
                  placeholder={placeholder}
                  value={formData[name]}
                  onChange={handleChange}
                  maxLength={1000}
                ></textarea>
              </div>
            ))}

            <div>
              <div className="create_inputbox1">Select Language</div>
              <select
                className="text_input"
                name="language"
                id="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="English">English</option>
                <option value="Arabic">Arabic (RTL)</option>
                <option value="Bulgarian">Bulgarian</option>
                <option value="Chinese">Chinese (Simplified)</option>
                <option value="French">French</option>
                <option value="German">German</option>
                <option value="Hebrew">Hebrew (RTL)</option>
                <option value="Hindi">Hindi</option>
                <option value="Indonesian">Indonesian</option>
                <option value="Italian">Italian</option>
                <option value="Japanese">Japanese</option>
                <option value="Portuguese">Portuguese</option>
                <option value="Punjabi">Punjabi</option>
                <option value="Russian">Russian</option>
                <option value="Spanish">Spanish</option>
                <option value="Swahili">Swahili</option>
                <option value="Tagalog">Tagalog</option>
                <option value="Urdu">Urdu</option>
              </select>
            </div>
          </div>
          <ToastContainer />
          <GoogleButton
            id="loginHidden"
            ref={googleAuthRef}
            onLoginSuccess={handleLoginSuccess}
            onLoginFailure={handleLoginFailure}
          />
          <button className="generate_btn" onClick={handleGenerate}>
            Generate for me
          </button>
        </div>
      </div>
    </>
  );
};

export default CriminalCharge;
